import React from 'react';
import { Trophy } from 'lucide-react';
import { DashCard, money } from './DashCard';

const SHADES = ['#1e3a8a', '#1d4ed8', '#2563eb', '#3b82f6', '#60a5fa'];

export const TopUnitsCard = ({ units = [] }) => {
  const max = Math.max(...units.map((u) => u.gross), 1);
  return (
    <DashCard title="Top 5 Units" subtitle="By gross · last 30 days" icon={Trophy} delay={260} testid="dashboard-top-units">
      {units.length === 0 ? (
        <div className="h-[200px] flex items-center justify-center text-sm text-slate-500 dark:text-slate-300">No loads in the last 30 days</div>
      ) : (
        <ol className="space-y-5">
          {units.map((u, i) => (
            <li key={u.unit_id || i} data-testid={`top-unit-${i}`}>
              <div className="flex items-baseline gap-2 text-sm">
                <span className="w-4 font-mono text-slate-500 dark:text-slate-300">{i + 1}</span>
                <span className="font-semibold text-slate-800 dark:text-slate-100 whitespace-nowrap">Unit {u.unit_number}</span>
                <span className="text-slate-500 dark:text-slate-300 truncate">{u.driver_name || 'Unassigned'} · {u.loads} loads</span>
                <span className="ml-auto font-mono font-semibold">{money(u.gross)}</span>
              </div>
              <div className="ml-6 mt-2 h-2.5 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                <div
                  className="h-full rounded-full dash-bar"
                  style={{ width: `${(u.gross / max) * 100}%`, background: SHADES[i], animationDelay: `${300 + i * 80}ms` }}
                />
              </div>
            </li>
          ))}
        </ol>
      )}
    </DashCard>
  );
};
